import React from 'react';

export default function MessageBox(props) {
  return (
    <div className={`form-control   form-control:hover form-control:focus alert alert-${props.variant || 'info'}`}>
      {props.children}
    </div>
  );
}
